import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { newDate } from '../../../utils/formatters';

function ShippingDateColumnCell({ values }) {
	const uniqueShippingValues = values
		.filter(({ shipDate }) => !!shipDate) // remove items without shipDate
		.reduce(
			(accumulator, item) => {
				const key = `${item.bol ?? 'no-bol'}-${item.shipDate}`;
				if (!accumulator.seen.has(key)) {
					accumulator.seen.add(key);
					accumulator.items.push({ key, shipDate: item.shipDate });
				}
				return accumulator;
			},
			{
				items: [],
				seen: new Set(),
			}
		).items;

	return (
		<>
			{uniqueShippingValues.map(({ key, shipDate }) => (
				<Typography key={key}>{newDate(shipDate)}</Typography>
			))}
		</>
	);
}

ShippingDateColumnCell.propTypes = {
	values: PropTypes.arrayOf(
		PropTypes.shape({
			shipDate: PropTypes.string,
		})
	),
};

export default ShippingDateColumnCell;
